// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"_1JHc5ARCxJTiqkALTFLJx"};